import quartz from './quartz.png'

export const QuartzIcon = <img src={quartz} alt='quartz' />
